import React from 'react'
import HeadSt from './HeadSt.css'
import { NavLink } from 'react-router-dom'
import CartBtn from './buttons/CartBtn'
import Login from './buttons/Login'
import Signup from './buttons/Signup'

const Header = () => {
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light" style={{backgroundColor: '#3d40dd'}}>
                <div className="container-fluid py-2">
                    
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">

                        <ul className="navbar-nav me-auto mb-2 mb-lg-0" >
                            
                            {/*left*/}
                            <li className="nav-item" id = "SCLB">
                            <NavLink className="nav-link" id = "SCLB" style={{color: 'white'}} to="/">SOCCER</NavLink>
                            </li>

                            <li className="nav-item" id = "SCLB" style={{maxWidth: 42}} >
                            <a href="/"><img src="/assets/images/bg/iconLogo.png" alt="" class="img-fluid"/></a>
                            </li>

                            <li className="nav-item" id = "SCLB">
                            <NavLink className="nav-link" id = "SCLB" style={{color: 'white'}} to="/">CLEATS</NavLink>
                            </li>
                            {/*left*/}


                            {/*<li className="nav-item">
                                 img src="/assets/images/bg/icon1.png"
                                <NavLink className="nav-link" style={{color: 'white'}}  aria-current="page" to="/">Home</NavLink>
                            </li>*/}
                        </ul>

                            {/*Right*/}
                            <ul className="navbar-nav" >
                            <li className="nav-item2">
                                <NavLink className="nav-link" style={{color: 'white'}}  to="/products">Products</NavLink>
                            </li>
                            <li className="nav-item2">
                                <NavLink className="nav-link" style={{color: 'white'}}  to="/about">About</NavLink>
                            </li>
                            <li className="nav-item2">
                                <NavLink className="nav-link" style={{color: 'white'}}  to="/contact">Contact Us</NavLink>
                            </li>                                                      
                        </ul>
                            {/*Right*/}
                    <CartBtn/>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Header
